var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "4" } },
            [
              _c("create-stock", {
                attrs: { edit: _vm.stockCategory },
                on: {
                  "update:edit": function($event) {
                    _vm.stockCategory = $event
                  }
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "8" } },
            [
              _c("table-stock", {
                attrs: { unit: _vm.stockCategoryUnit },
                on: {
                  "update:unit": function($event) {
                    _vm.stockCategoryUnit = $event
                  }
                },
                model: {
                  value: _vm.stockCategory,
                  callback: function($$v) {
                    _vm.stockCategory = $$v
                  },
                  expression: "stockCategory"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c("stock-category-unit", {
        model: {
          value: _vm.stockCategoryUnit,
          callback: function($$v) {
            _vm.stockCategoryUnit = $$v
          },
          expression: "stockCategoryUnit"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }